export const NORMAL = 'NORMAL';
export const WARNING = 'WARNING';
export const DANGER = 'DANGER';
export const WARNING_RATIO = 0.1;
